import React, { FC, useMemo } from 'react';
import { PropertiesPanel } from 'src/components/pages/productConfiguration/steps/configurator-components/scene-properties-panel';
import { CameraCartOutput, CameraLocationHelpers, CameraLocationNode, useCameraLocationPropertiesCreator } from '../cameraEditorConfig';
import InspectorShell from '../inspectorShell';

// L'involucro sta in `InspectorShell`, uno per tutti i generi: qui resta ciò che è solo di una
// camera salvata. Le proprietà le costruisce `cameraEditorConfig`, che è anche il posto dove sta
// scritto perché sono soltanto due.

export interface CameraLocationOverlayProps {
    name: string;
    camera: CameraLocationNode;
    /** Il nome si cambia anche dalla testata, come per ogni altro soggetto. */
    onRename?: (name: string) => void;
    /** Cart preview image + Number: il posto di questa camera nel riepilogo ordine. */
    output?: CameraCartOutput;
    onChange: CameraLocationHelpers['onChange'];
    /** «Dove sta?» — la freccetta della testata: accende la riga di questa camera nell'elenco. */
    onReveal?: () => void;
}

const CameraLocationOverlayComponent: FC<CameraLocationOverlayProps> = ({ name, camera, onRename, onChange, onReveal, output }) => {
    const createCameraLocationProperties = useCameraLocationPropertiesCreator();

    const helpers: CameraLocationHelpers = useMemo(() => ({ onChange, output }), [onChange, output]);
    const properties = useMemo(() => createCameraLocationProperties(camera, helpers), [createCameraLocationProperties, camera, helpers]);

    return (
        <InspectorShell kind='camera' name={name} onRename={onRename} onReveal={onReveal}>
            <PropertiesPanel properties={properties} />
        </InspectorShell>
    );
};

export default CameraLocationOverlayComponent;
